import { Skeleton } from '@material-ui/lab';
import { Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';

export function VehicleSubhaulDrawerLoader() {
  return (
    <Stack space="small">
      <Box paddingTop="xsmall" paddingLeft="medium" paddingRight="medium">
        <Skeleton variant="text" width="40%" height={24} />
      </Box>

      <Box paddingLeft="large" paddingRight="large">
        <Box
          padding="small"
          borderColor="Silver400"
          borderWidth="small"
          borderRadius="small"
        >
          <Stack space="small">
            <Skeleton variant="text" width="70%" height={20} />
            <Stack space="xsmall">
              <Skeleton variant="text" width="55%" height={20} />
              <Skeleton variant="text" width="55%" height={20} />
            </Stack>
            <Skeleton variant="text" width="45%" height={20} />
          </Stack>
        </Box>
      </Box>

      <Box paddingLeft="large" paddingRight="large">
        <Stack space="xsmall">
          <Skeleton variant="rect" width="100%" height={40} />
          <Skeleton variant="rect" width="100%" height={40} />
        </Stack>
      </Box>

      <Box paddingLeft="large" paddingRight="large">
        <Skeleton variant="rect" width="100%" height={40} />
        <Skeleton variant="rect" width="100%" height={40} />
      </Box>

      <Box paddingLeft="large" paddingRight="large">
        <Skeleton variant="rect" width="100%" height={40} />
        <Skeleton variant="rect" width="100%" height={40} />
      </Box>
    </Stack>
  );
}
